/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { environment, store } from '@rb-serve-app/core';
import { Provider } from 'react-redux';
import { QueryClientProvider, QueryClient } from 'react-query';
import './useDynamicShareButtonPosition'; // Ensure the hook is available
import { getBrazePushDebugStatus } from './config/braze';

declare const __DEV__: boolean;

// registerSW();

if (!(environment.env === 'qa' || environment.env === 'development')) {
  console.log = () => {};
  console.warn = () => {};
}

declare global {
  interface Window {
    _trackData: (trackData: any) => void;
    __brazePushDebugStatus?: () => Promise<void>;
  }
}

// Dynatrace and Adobe DTM script loading
const dynaScriptUrl = environment.dynaBeaconUrl;
const dtmScriptUrl = environment.REACT_APP_ADOBE_DTM_URL;

if (dtmScriptUrl) {
  const script = document.createElement('script');
  script.src = dtmScriptUrl;
  script.async = true;
  document.head.appendChild(script);
}

if (dynaScriptUrl) {
  const dynaScript = document.createElement('script');
  dynaScript.src = dynaScriptUrl;
  dynaScript.async = true;
  dynaScript.crossOrigin = 'anonymous';
  document.head.appendChild(dynaScript);
}

if (environment.env !== 'production') {
  globalThis.window.__brazePushDebugStatus = async () => {
    const status = await getBrazePushDebugStatus();
    console.log('[Braze][Debug][PushStatus]', status);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const client = new QueryClient();

const Main = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={client}>
        <App />
      </QueryClientProvider>
    </Provider>
  );
};

root.render(<Main />);
